
declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
        fbq: (...args: any[]) => void;
        _fbq: any;
    }
}

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-BF2BV5G5RK'; // Fallback to the one found in index.html

export const Analytics = {
    // Initialize GA4 and Meta Pixel
    init: () => {
        // 1. Google Analytics
        if (GA_MEASUREMENT_ID) {
            if (!document.getElementById('ga-script')) {
                const script = document.createElement('script');
                script.id = 'ga-script';
                script.async = true;
                script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
                document.head.appendChild(script);

                window.dataLayer = window.dataLayer || [];
                function gtag(...args: any[]) {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag;
                gtag('js', new Date());
                gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
                console.log(`[Analytics] GA initialized: ${GA_MEASUREMENT_ID}`);
            }
        }

        // 2. Google Ads (Optional - if manual conversion was created)
        const GOOGLE_ADS_ID = import.meta.env.VITE_GOOGLE_ADS_ID;
        if (GOOGLE_ADS_ID && window.gtag) {
            window.gtag('config', GOOGLE_ADS_ID);
            console.log(`[Analytics] Google Ads initialized: ${GOOGLE_ADS_ID}`);
        }

        // 3. Meta Pixel (Facebook)
        const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID;
        if (META_PIXEL_ID && !document.getElementById('meta-pixel-script')) {
            const script = document.createElement('script');
            script.id = 'meta-pixel-script';
            script.innerHTML = `
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${META_PIXEL_ID}');
                fbq('track', 'PageView');
            `;
            document.head.appendChild(script);
            console.log(`[Analytics] Meta Pixel initialized: ${META_PIXEL_ID}`);
        }
    },

    // Track Page View
    pageView: (path: string) => {
        // GA4
        if (window.gtag) {
            window.gtag('event', 'page_view', {
                page_path: path,
                page_title: document.title
            });
        }
        // Meta Pixel automatically tracks PageView on init, but for SPA transitions:
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
    },

    // Track Custom Event
    event: (eventName: string, params: Record<string, any> = {}) => {
        // GA4
        if (window.gtag) {
            window.gtag('event', eventName, params);
        }

        // Meta Pixel (Map common events)
        if (typeof window.fbq === 'function') {
            // Map standard events if possible, else CustomEvent
            const standardEvents = ['Purchase', 'Lead', 'CompleteRegistration', 'AddToCart', 'InitiateCheckout', 'Subscribe'];
            if (standardEvents.includes(eventName)) {
                window.fbq('track', eventName, params);
            } else {
                window.fbq('trackCustom', eventName, params);
            }
        }

        console.log(`[Analytics] Event: ${eventName}`, params);
    }
};

export default Analytics;
